(function ($) {
  DJ.addBehavior('btnModal', '.btn--modal-wrapper', {
    attach: function () {
      const $button = $('.btn--modal', $(this));
      const $modalContent = $('.btn--modal-content', $(this));
      const data = {
        title: $button.data('title'),
        icon: $button.data('icon'),
        body: $modalContent.html(),
        customModalClass: $button.data('custom-modal-class')
      };

      /**
       * Remove cloned content.
       */
      $modalContent.html('');

      /**
       * Theme for modal.
       */
      const themeModal = (content) => {
        let output = '';
        output += `<div class="cems-modal ${content.customModalClass ? content.customModalClass : ''}">`;
        output += '<div class="cems-modal__wrapper">';
        output += '<div class="cems-modal__content">';
        output += `<button aria-label="${Drupal.t('Close popup')}" class="cems-modal__close"></button>`;
        if (content.title && !content.icon) {
          output += `<h3 class="cems-modal__title">${content.title}</h3>`;
        }
        if (content.icon && content.title) {
          output += `<h3 class="cems-modal__title"><span class="svg-icon"><svg><use xlink:href="${content.icon}"></use></svg></span>${content.title}</h3>`;
        }
        if (content.icon && !content.title) {
          output += `<h3 class="cems-modal__title"><span class="svg-icon"><svg><use xlink:href="${content.icon}"></use></svg></span></h3>`;
        }
        output += content.body;
        output += '</div>';
        output += '</div>';
        output += '</div>';
        return output;
      };

      let $modal = $(themeModal(data));

      /**
       * Close video modal.
       */
      const onClose = () => {
        $modal.removeClass('video-modal--opened');
        document.getElementsByTagName('html')[0].classList.remove('html--locked');
        $('body').off('click.bodyCloseVideoModal');
        $(document).off('keydown.escCloseVideoModal');

        const bodyTimer = setTimeout(() => {
          $modal.remove();
          clearTimeout(bodyTimer);
        }, 500);
      };

      /**
       * Close video modal on body click.
       */
      const onBodyClick = () => {
        $('body').on('click.bodyCloseVideoModal', (e) => {
          if (!($(e.target).closest('.cems-modal__content').length)) {
            onClose();
          }
        });
      };

      /**
       * Close video modal on esc key press.
       */
      const onEscKeyPress = () => {
        $(document).on('keydown.escCloseVideoModal', (e) => {
          if (e.code === 'Escape') {
            onClose();
          }
        });
      };

      /**
       * Open video modal by click on a button.
       * If the modal was opened from a slider - slider autoplay stops.
       * HTML and body are locked(not possible to scroll) while the modal is opened.
       */
      $button.on('click', (e) => {
        e.preventDefault();
        $modal = $(themeModal(data));
        $(document.body).append($modal);
        $('.jcf-scrollable-wrapper').removeAttr('style');
        $('.change-school-accordion__scroll-wrapper').removeAttr('style');
        DJ.attachBehavior('changeSchool');
        DJ.behaviors.userPictureUpload.userPictureUploadInit();
        document.getElementsByTagName('html')[0].classList.add('html--locked');
        const bodyTimer = setTimeout(() => {
          $modal.addClass('cems-modal--opened');
          onBodyClick();
          onEscKeyPress();
          clearTimeout(bodyTimer);
        }, 50);
      });

      /**
       * Close video modal on a close button click.
       */
      $('body').on('click', '.cems-modal__close', () => {
        onClose();
      });
    }
  });
})(jQuery);
